import { render, staticRenderFns } from "./areaSelectWindow.vue?vue&type=template&id=395fbd8f"
import script from "./areaSelectWindow.vue?vue&type=script&lang=js"
export * from "./areaSelectWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports